/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * One line on a manually-composed Spiris invoice. Mirrors FortnoxInvoiceRowDto - no Vat/AccountNumber
 * fields, since the Spiris invoice-draft row API has no such fields (VAT is derived from the
 * referenced article in Spiris itself, not set per-row).
 * @export
 * @interface WebApiIntegrationsDtoSpirisInvoiceRowDto
 */
export interface WebApiIntegrationsDtoSpirisInvoiceRowDto {
    /**
     * Row text. Required.
     * @type {string}
     * @memberof WebApiIntegrationsDtoSpirisInvoiceRowDto
     */
    description?: string | null;
    /**
     * Unit price excluding VAT.
     * @type {number}
     * @memberof WebApiIntegrationsDtoSpirisInvoiceRowDto
     */
    amount?: number;
    /**
     * Optional Spiris article to bill the row as.
     * @type {string}
     * @memberof WebApiIntegrationsDtoSpirisInvoiceRowDto
     */
    articleNumber?: string | null;
    /**
     * Delivered quantity. Defaults to 1.
     * @type {number}
     * @memberof WebApiIntegrationsDtoSpirisInvoiceRowDto
     */
    quantity?: number;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoSpirisInvoiceRowDto interface.
 */
export function instanceOfWebApiIntegrationsDtoSpirisInvoiceRowDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoSpirisInvoiceRowDtoFromJSON(json: any): WebApiIntegrationsDtoSpirisInvoiceRowDto {
    return WebApiIntegrationsDtoSpirisInvoiceRowDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoSpirisInvoiceRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoSpirisInvoiceRowDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'articleNumber': !exists(json, 'articleNumber') ? undefined : json['articleNumber'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
    };
}

export function WebApiIntegrationsDtoSpirisInvoiceRowDtoToJSON(value?: WebApiIntegrationsDtoSpirisInvoiceRowDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'amount': value.amount,
        'articleNumber': value.articleNumber,
        'quantity': value.quantity,
    };
}

